module.exports = __webpack_public_path__ + "img/choose-repositories.c977e26.svg";